import { FunctionComponent, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { deleteProject } from "../../../Services/contacts";
import { showSnackbarAction } from "../../../Redux/actions";
import { themeColors } from "../../theme";
import "../../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Modal, { Styles } from "react-modal";
import StyledCancelButton from "../../Buttons/StyledCancelButton";
import { Circles } from "react-loader-spinner"

// -------------------------------------------------------------
// Props Interface
// -------------------------------------------------------------
type props = {
    open: boolean;
    close: () => void;
    data: any;
    totalData: any;
    organization_id: any;
    clearSelectedRowsData?: () => void;
    theme: any;
};

// -------------------------------------------------------------
// DeleteProjectSelectedModal Component
// -------------------------------------------------------------
const DeleteProjectSelectedModal: FunctionComponent<props> = ({
    open,
    close,
    clearSelectedRowsData,
    data,
    totalData,
    organization_id,
    theme
}) => {
    // MUI theme & responsiveness
    const themeMUI = useTheme();
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

    // Loader state
    const [load, setLoad] = useState(false);

    // Redux dispatcher
    const dispatcher = useDispatch();


    // -------------------------------------------------------------
    // Delete selected project entries
    // Only deletes rows where status === "Pre Launch"
    // -------------------------------------------------------------
    const deleteProjectFirebase = () => {
        if (data) {
            let notLaunchFilter: any[] = [];
            let filterData: any[] = [];
            data.map((item: any) => {
                if (item.project_status === "Pre Launch") {
                    notLaunchFilter.push(item);
                }
                else {
                    filterData.push(item)
                }
            })
            setLoad(true);
            let newIndex: number;
            let finalIndex = [];
            for (let item of notLaunchFilter) {
                newIndex = totalData.findIndex((i: { project_name: any; }) => i.project_name === item.project_name);
                finalIndex.push(newIndex);
            }
            // Sort in ascending order before deleting
            finalIndex.sort();

            // Call backend delete function
            // for (let item of data) {
            deleteProject(
                organization_id,
                totalData,
                finalIndex,
                dispatcher,
                (item) => setLoad(item)
            );
            // }
        }
        // Wait for Cloud Function → then cleanup
        setTimeout(() => {
            close();
            setLoad(false);
            dispatcher(showSnackbarAction("Record Deleted", "success"));
            clearSelectedRowsData && clearSelectedRowsData();
            window.location.reload();
        }, 2500);
    };

    // -------------------------------------------------------------
    // Modal Style Configuration
    // -------------------------------------------------------------
    const modalStyle: Styles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // darkens the background
            zIndex: 1300, // higher than MUI AppBar/Table
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        content: {
            background: theme
                ? themeColors.cardBackgroundColor
                : themeColors.cardBackgroundColorDark,
            color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
            borderRadius: 16,
            padding: isMobile ? "24px 12px" : "40px 32px",
            maxWidth: 380,
            minWidth: 320,
            border: "none",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            inset: "auto",
            margin: "auto",
        },
    };

    // -------------------------------------------------------------
    // UI Rendering
    // -------------------------------------------------------------
    return (
        <>
            <Modal
                isOpen={open}
                onRequestClose={close}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                style={modalStyle}
                ariaHideApp={false}
            >

                <Box
                    sx={{
                        width: "100%",
                        maxWidth: 340,
                        mx: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >
                    <form style={{ width: "100%" }}>

                        {/* ---------------- Modal Title ---------------- */}
                        <Box sx={{ mb: 2 }}>
                            <h3
                                style={{
                                    color: theme ? "#272944" : "#fff",
                                    fontFamily: "var(--font-family-main)",
                                    fontSize: "var(--font-size-large)",
                                    marginBottom: 24,
                                    textAlign: "center",
                                    letterSpacing: 0.5,
                                }}
                            >
                                Are you sure you want to delete the records?
                            </h3>
                        </Box>

                        {/* ---------------- Display Selected Pre Launch Projects ---------------- */}
                        <Grid container spacing={2} sx={{ width: "100%", mt: 2, maxHeight: 200, overflowY: 'auto' }}>
                            <ol>
                                {data.filter((i: any) => i.project_status === "Pre Launch")?.map((dat: any) => (
                                    <li>{dat.project_name}</li>
                                ))}
                            </ol>
                        </Grid>

                        {/* ---------------- Buttons ---------------- */}
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    mt: 4,
                                    width: "100%",
                                }}
                            >
                                <Box style={{ marginRight: 8 }}>
                                    {/* Cancel Button */}
                                    <StyledCancelButton onClick={close} isMobile={isMobile}>
                                        Cancel
                                    </StyledCancelButton>
                                </Box>
                                <Box>
                                    {/* Delete Button */}
                                    <StyledCancelButton
                                        onClick={deleteProjectFirebase}
                                        isMobile={isMobile}
                                    >
                                        {load ? (
                                            <span style={{ display: "flex", justifyContent: "center" }}>
                                                <Circles color="#fff" height={20} width={20} />Deleting...
                                            </span>
                                        ) : (
                                            <>Delete</>
                                        )}
                                    </StyledCancelButton>
                                </Box>
                            </Box>
                        </Grid>
                    </form>
                </Box>
            </Modal >
        </>
    );
};

// -------------------------------------------------------------
// Redux → inject theme into component
// -------------------------------------------------------------
const mapStateToProps = (state: any) => {
    return {
        theme: state.theme.isLightMode
    };
};
export default connect(mapStateToProps)(DeleteProjectSelectedModal);
